import { convertWithUnits } from './math-utils';

export const merge = require( 'lodash.merge' );

export const cloneDeep = require( 'lodash.clonedeep' );

export function log(){
	console.log( ...arguments );
}

// determine how many max stages are involved in a proposal flow
export function maxStages( { proposal, responses } ){

	let questionId = 0;

	if( responses.length ){
		questionId = responses[ responses.length - 1 ].result;
	}

	function crawl( id ){

		let hits = 0;
		let max = 0;

		for( const q of proposal.questions ){

			if( q.id === id ){

				// we've matched the question
				hits = 1;

				// no we need to see which sub-branch yields the most hits
				if( isArray( q.answers ) ){

					for( const r of q.answers ){

						let subHits = 0;

						// do we have another step?
						if( Number.isInteger( Number( '' + r.result ) ) ){

							subHits += crawl( r.result );

						}

						// do we have a longer branch?
						if( subHits > max ){
							max = subHits;
						}

					}
				}

				break;

			}
		}

		return hits + max;

	}

	// max number of sub-questions + responses already submitted
	return crawl( questionId ) + responses.length;

}

export function isArray( a ){
	return a && typeof a.forEach === 'function';
}

// load initial state from local storage
export function loadState( defaultState ){

	let loadedState = localStorage.state;

	try{

		loadedState = JSON.parse( loadedState );

		// have keys been added / removed?
		if( JSON.stringify( Object.keys( loadedState ) ) !== JSON.stringify( Object.keys( defaultState ) ) ){
			loadedState = {};
		}

	}
	catch( e ){
		loadedState = {};
	}

	// copy default state - do not use directly, otherwise there will be confusion
	const state = cloneDeep( defaultState );

	return merge( state, loadedState );

}

// save state to local storage
export function saveState( state ){
	localStorage.state = JSON.stringify( state );
}


export function matchAnswer( question, value ){

	const opt = ( typeof value === 'object' ) ? value : { value };

	for( const answer of question.answers ){

		let val = opt.value;

		// convert value for comparison if required
		if( opt.unit && answer.unit ){
			val = convertWithUnits( val, opt.unit, answer.unit );
		}

		const result = matchOperator( val, answer.operator, answer.value );

		log( val, answer.operator, answer.value, result );

		// do we have a match?
		if(	result ){
			return answer;
		}


	}

	return null;

}

export function matchOperator( value1, operator, value2 ){

	switch( operator ){

		case '=':
			return value1 === value2;

		case '>':
			return value1 > value2;

		case '<':
			return value1 < value2;

		case '>=':
			return value1 >= value2;

		case '<=':
			return value1 <= value2;

		default:
			throw new ReferenceError( 'Unknown operator: '+operator );

	}

}
